import { isMiniProgramChannel } from "./productNavigation";

export function openPrivacyPolicy(): void {
  if (isMiniProgramChannel(window.location.search) && window.wx?.miniProgram?.navigateTo) {
    try {
      window.wx.miniProgram.navigateTo({ url: "/pages/privacy/index" });
      return;
    } catch {
      // The same-origin H5 policy remains available as a safe fallback.
    }
  }
  window.location.assign("/privacy.html");
}
